<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <div>
        <Breadcrumbs headline="Công nợ" :link="[{ text: 'Công nợ', href: '/debt-config' }]" />
      </div>
    </div>
    <v-card outlined class="mx-4 mb-6 elevation-0">
      <TableDebt />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TableDebt from '../../modules/debtConfig/TableDebt.vue'
export default {
  components: {
    Breadcrumbs,
    TableDebt
  }
}
</script>
